import React from "react";
import { Row, Col, FormGroup, Label, Input, Button } from "reactstrap";

const StoryForm = ({
  prompt,
  setPrompt,
  numScenes,
  setNumScenes,
  selectedImage,
  mascotImage,
  handleImageUpload,
  onGenerate,
  loading
}) => {
  return (
    <Row className="mb-4">
      <Col md={6}>
        <FormGroup>
          <Label>Story Prompt</Label>
          <Input
            type="textarea"
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            placeholder="Enter your story idea..."
            rows={4}
          />
        </FormGroup>

        <FormGroup>
          <Label>Number of Scenes</Label>
          <Input
            type="select"
            value={numScenes}
            onChange={(e) => setNumScenes(parseInt(e.target.value))}
          >
            <option value={2}>2 Scenes</option>
            <option value={3}>3 Scenes</option>
            <option value={4}>4 Scenes</option>
            <option value={5}>5 Scenes</option>
            <option value={6}>6 Scenes</option>
          </Input>
        </FormGroup>
      </Col>

      <Col md={6}>
        <FormGroup>
          <Label>Character Image (Optional)</Label>
          <Input
            type="file"
            accept="image/*"
            onChange={handleImageUpload}
          />
          {(selectedImage || mascotImage) && (
            <div className="mt-2">
              <img
                src={`data:${(selectedImage || mascotImage).mimeType};base64,${(selectedImage || mascotImage).base64Data}`}
                alt="Character Reference"
                style={{
                  width: "100px",
                  height: "100px",
                  objectFit: "cover",
                  borderRadius: "8px",
                }}
              />
              <p className="small text-muted mt-1">
                {selectedImage ? "Custom character" : "Mascot reference"} - will appear in scenes when mentioned
              </p>
            </div>
          )}
        </FormGroup>
      </Col>

      <Col xs={12}>
        <Button
          color="primary"
          onClick={onGenerate}
          disabled={loading || !prompt.trim()}
        >
          {loading ? (
            <>
              <i className="fa fa-spinner fa-spin me-1"></i>
              Generating Story...
            </>
          ) : (
            "Generate Story"
          )}
        </Button>
      </Col>
    </Row>
  );
};

export default StoryForm;